module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_intro",
    attrs: {
      "epub:type": "introduction"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("INTRODUCTION")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("I (throughout this book, “I” refers to me) have served as an active missionary for 52 years, first as an urban evangelist, and then an international mobilizer of prayer and workers for the least evangelized on earth. The Great Commission of Matthew 28:16-20, with Jesus’ core injunction to disciple all nations, has been fundamental to my ministry. My work in producing the various editions of "), _c('i', [_vm._v("Operation World")]), _vm._v(" was a big part of that.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("My latter book, "), _c('i', [_vm._v("The Future of the Global Church")]), _vm._v(", was specifically written in 2011 as a handover of my public ministry to a new generation of mobilizers by giving a global vision and the tools to portray it. This book covered much ground in its 240 pages, but these could give only some broad strokes of the challenges and possibilities for future ministry.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Jon Hirst, the CEO of GMI, had the vision of expanding on some of that book’s themes by publishing a series of more specific books, of which this volume on urbanization is the first.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Dean Merrill was approached to do the main task of compiling the text, drawing upon hours of interaction with me and with further research. I have been delighted to work closely with Dean in the writing of this book and am very pleased with the results as well as the efficiency with which he has accomplished it.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("My prayer is that God will use this effort both to call new workers to the world’s cities and to refine existing ministries.")]), _c('p', {
    staticClass: "sign"
  }, [_vm._v("Patrick Johnstone"), _c('br'), _vm._v("WEC International"), _c('br'), _vm._v("Author Emeritus, "), _c('i', [_vm._v("Operation World")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30defbe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre3.vue
// module id = 66
// module chunks = 0